<template>
  <v-container>
    <v-row>
      <v-col><h3>{{extractMileageString()}}<small class="ml-2">({{zeroSum}})</small></h3></v-col>
      <v-col cols="auto"><v-checkbox v-model="showZero" class="mt-0" hide-details></v-checkbox></v-col>
    </v-row>
    <v-row>
      <v-col cols=auto>
        <v-btn tile small @click="visibleHistory=true">HISTORY</v-btn>
      </v-col>
      <v-spacer></v-spacer>
      <v-col cols="auto">
        <v-btn color="info" tile small @click="sorting">SORT</v-btn>
        <v-btn color="warning" tile small @click="reset">RESET</v-btn>
        <v-btn color="success" tile small @click="save">SAVE</v-btn>
      </v-col>
    </v-row>
    <div :key="remounter">
      <v-row>
        <v-col
            v-for="(item,i) in items" :key="i"
            :cols="12"
        >
          <ts-mileage-item :player="item"></ts-mileage-item>
        </v-col>
      </v-row>
    </div>
    <v-dialog
        v-model="visibleHistory"
        fullscreen
    >
      <v-sheet height="100%" width="100%">
        <v-row style="margin:0;">
          <v-col cols="auto"><h3>저장기록</h3></v-col>
          <v-spacer></v-spacer>
          <v-col cols="auto" icon @click="visibleHistory = false"><v-icon>mdi-close</v-icon></v-col>
        </v-row>
        <v-data-table
            :headers="historyHeaders"
            :items="histories"
            hide-default-footer
            height="100%"
        >
        </v-data-table>
      </v-sheet>
    </v-dialog>
  </v-container>
</template>

<script>
import {getPlayers, savePlayer} from "@/api/player";
import {getMileages, insertMileages} from "@/api/mileage";
import TsMileageItem from "../components/TsMileageItem";
import {strEquals} from "@/util/nativeHelper";

export default {
  name: "Mileage",
  components: {TsMileageItem},
  data() {
    return {
      showZero: false,
      remounter: 0,
      visibleHistory: false,
      historyHeaders: [
        {
          value: 'content',
          text: 'content',
        },
        {
          value: 'create_date',
          text: 'Create',
        },
        {
          value: 'create_user_name',
          text: 'User'
        }
      ],

      players: [],
      mileages: [],
    }
  },
  computed:{
    items(){
      return this.players.filter(p => this.showZero || p.mileage !== 0)
    },
    zeroSum(){
      return this.players.map(p => p.mileage).reduce((a,b) => a + b,0);
    },
    histories(){
      const {mileages} = this
      return mileages
    },
  },
  async mounted () {
    this.players = await getPlayers()
    this.mileages = await getMileages()
    this.sorting()
  },
  methods: {
    addMileageResult(resultList) {
      try {
        resultList.forEach(result => {
          const findPlayer = this.players.find(({name, player_id}) =>
              result.player_id ? strEquals(result.player_id, player_id) :
                  name === result.name
          )
          findPlayer.mileage -= -result.mileage
          findPlayer.changed = true
        })
        return this.players
      } catch (e){
        return false
      }
    },
    calculateMileageFromRecords(records){
      try{
        const result = {}
        for (let record of records) {
          record.winners.forEach((p) => {
            result[p] = result[p] || 0
            result[p]++
          })
          record.losers.forEach((p) => {
            result[p] = result[p] || 0
            result[p]--
          })
        }
        return Object.entries(result).map(([name, mileage]) => ({
          name,
          mileage
        }))
      }catch(e) {
        return false
      }
    },
    sorting(){
      this.players.sort((a,b) => b.mileage - a.mileage)
    },
    reset(){
      this.players.forEach(value => value.mileage = 0)
    },
    checkZeroSum(){
      const {players} = this
      const sum = players.map(p => p.mileage).reduce((a,b) => a + b,0);
      if(sum !== 0 || !players.some(p => p.changed)) return false
      return true
    },
    extractMileageString(players){
      players = players || this.players
      const sortedPlayers = players.filter(a => a.mileage !== 0)
      sortedPlayers.sort(((a, b) => a.mileage - b.mileage))
      const centerIndex = sortedPlayers.findIndex((a,i) => a.mileage > 0 && sortedPlayers[i-1].mileage < 0)
      return sortedPlayers.map((p,i) =>
          (i === centerIndex ? '>' : '')
          + `${p.name.substr(0,1)}${Math.abs(p.mileage)}`
      ).join('')
    },
    async save(){
      if(!this.checkZeroSum()) return this.$alert('제로썸 혹은 no changes detected')
      let content = this.extractMileageString()
      await insertMileages(content, this.$session.get('loginUser'))
      await Promise.all(this.players.map(({player_id,mileage}) =>
        savePlayer({player_id, mileage})
      ))
      this.mileages = await getMileages()
      await this.$alert('저장완료')
      this.remounter++
    }
  }
}
</script>

<style scoped>

</style>
